import * as types from './actionsTypes.analytics';

export const trackPaymentStart = (param) => ({
    type: types.TRACK_PAYMENT_REQ,
    ...param
});

export const trackPaymentError = (param) => ({
    type: types.TRACK_PAYMENT_ERR,
    ...param
});

export const trackPaymentSuccess = (param) => ({
    type: types.TRACK_PAYMENT_OK,
    ...param
});

export const trackUserAction = (param) => ({
    type: types.TRACK_USER_ACTION_REQ,
    ...param
});

export const trackPlanAction = (param) => ({
    type: types.TRACK_PLAN_ACTION_REQ,
    ...param
});
